import className from '../../../../../home24-shared/components/quickview/constants/classNames-swiper';
import { reRender } from '../render/render';
import notSellable from '../render/notSellable';

const currentValuesSelected = (selectoptions, selectedMvcAttributes) => {
  return Object.keys(selectedMvcAttributes)
    .map(key => selectoptions[key].value)
    .sort();
};

const findCorrectSku = (otherSkus, selected) => {
  const findsku = Object.keys(otherSkus).filter(key => {
    const arr = Object.values(otherSkus[key].selectedMvcAttributes).sort();
    return (
      arr.length === selected.length &&
      arr.every((element, index) => {
        return element === selected[index];
      })
    );
  });
  if (!findsku) {
    return;
  }
  if (findsku.length === 0) {
    return undefined;
  }
  if (otherSkus[findsku[0]].isSellable === false) {
    return undefined;
  }
  return otherSkus[findsku[0]].sku;
};

const findAlternativeSku = (otherSkus, targetvalue) => {
  let skuarr = Object.keys(otherSkus).filter(key => {
    return otherSkus[key].isSellable === true && key.includes(targetvalue);
  });

  if (skuarr.length === 0 || skuarr === undefined) {
    skuarr = Object.keys(otherSkus).filter((key = otherSkus[key].isSellable));
  }

  return otherSkus[skuarr[0]].sku;
};

const addEventListenerToOptions = (
  config,
  otherSkus,
  selectedMvcAttributes
) => {
  const selectoptions = document.getElementsByClassName(
    className.DETAILS.OPTIONS.SELECT
  );
  for (let i = 0; i < selectoptions.length; i++) {
    const element = selectoptions[i];
    element.addEventListener('change', e => {
      const selected = currentValuesSelected(
        selectoptions,
        selectedMvcAttributes
      );
      const selectedChildSku = findCorrectSku(otherSkus, selected);
      if (!selectedChildSku) {
        const alternativeSku = findAlternativeSku(otherSkus, e.target.value);
        notSellable(config, alternativeSku);
        return null;
      }

      reRender(selectedChildSku);
    });
  }
};

export const removeEventListenerToOptions = () => {
  const selectoptions = document.getElementsByClassName(
    className.DETAILS.OPTIONS.SELECT
  );
  if (selectoptions === undefined || selectoptions === null) {
    return null;
  }
  for (let i = 0; i < selectoptions.length; i++) {
    const element = selectoptions[i];
    $(element).off();
  }
};

export default addEventListenerToOptions;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/functions/eventListeners/options.js
 **/